import { _ } from "core-js"
import Vue from "vue"

const axios = require("axios")
const http = axios.create()

let abortController = {}

http.interceptors.request.use(
    async (config) => {
        let abortActive = _.get(config, "abort", true)
        const token = window.TenantGlobals.token
        config.headers.Authorization = `Bearer ${token}`
        if (abortActive) {
            if (_.get(abortController, config.url, false)) {
                abortController[config.url].abort()
            }
            Vue.set(abortController, config.url, new AbortController())
            config.signal = abortController[config.url].signal
        }
        return config
    },
    (error) => {
        error.output = function () {
            if (error.message !== "canceled") {
                return console.error(error)
            }
            return true
        }
        Promise.reject(error)
    }
)

// Response interceptor for API calls
http.interceptors.response.use(
    (response) => {
        Vue.delete(abortController, response.config.url)
        return response
    },
    async function (error) {
        const originalRequest = error.config

        if (_.get(error, "response", false)) {

            window.onbeforeunload = null

            if (error.response.status == 401) {
                this.$store.dispatch("global commit", {
                    type: "ambition/setActiveSession",
                    payload: false,
                })
                window.location = window.location.href
            }

            if (error.response.status === 403 && !originalRequest._retry) {
                originalRequest._retry = true
                window.location = window.location.href
            }
        }

        error.output = function () {
            if (error.message !== "canceled") {
                return console.error(error)
            }
            return true
        }

        return Promise.reject(error)
    }
)

export default http
